var login = {
  translation: {
    common: {
      accept: 'Accetta',
      alreadyUser: 'Gia utente?',
      and: 'e',
      backToLogin: 'Torna alla pagina di login',
      continueWith: 'Continua con {{provider}}',
      createAccount: 'Crea un account',
      createYourAccount: 'Crea il tuo account',
      emailOrUsername: 'Email o nome utente',
      login: 'Accedi',
      logInToBoards: 'Accedi',
      newToBoards: 'Nuovo su 4ga Boards?',
      pageNotFound_title: 'Pagina non trovata',
      password: 'Password',
      privacyPolicy: 'Informativa sulla privacy',
      register: 'Registrati',
      registerWithGoogle: 'Registrati con Google',
      termsOfService: 'Termini di servizio',
      togglePasswordVisibility: 'Mostra/nascondi password',
    },

    action: {
      logIn: 'Accedi',
    },
  },
};

export { login as default };
